// Using actual values for the enums rather than numeric (to help debug and some protection)
export enum AuthRedirectPage {
  Create = 'create',
  CreateValidate = 'createVal',
  Password = 'pass',
  PasswordMore = 'passMore',
  PasswordSuccess = 'passSuccess',
  PasswordValidate = 'passVal',
  Login = 'login',
  LoginSuccess = 'loginSuccess',
  Signup = 'signup',
  SignupAccountInfo = 'signupAcc',
  SignupCheckEmail = 'signupCheck',
  SignupUserInfo = 'signupUser',
  SignupValidate = 'signupValidate',
  Username = 'user',
  UsernameMore = 'userMore',
  UsernameSuccess = 'userSuccess',
}

export const AuthRedirectPagePaths = {
  [AuthRedirectPage.Create]: '/create',
  [AuthRedirectPage.CreateValidate]: '/create/validate',
  [AuthRedirectPage.Password]: '/password',
  [AuthRedirectPage.PasswordSuccess]: '/password/success',
  [AuthRedirectPage.PasswordMore]: '/password/more',
  [AuthRedirectPage.PasswordValidate]: '/password/validate',
  [AuthRedirectPage.Login]: '/',
  [AuthRedirectPage.LoginSuccess]: '/login/success',
  [AuthRedirectPage.Signup]: '/signup',
  [AuthRedirectPage.SignupAccountInfo]: '/signup/account-info',
  [AuthRedirectPage.SignupCheckEmail]: '/signup/check-email',
  [AuthRedirectPage.SignupUserInfo]: '/signup/user-info',
  [AuthRedirectPage.SignupValidate]: '/signup/validate',
  [AuthRedirectPage.Username]: '/username',
  [AuthRedirectPage.UsernameMore]: '/username/more',
  [AuthRedirectPage.UsernameSuccess]: '/username/success',
} as const;

/**
 * Query parameter keys used across the auth flow.
 */
export enum AuthSearchParam {
  App = 'app',
  AuthUsername = 'u',
  Code = 'code',
  Email = 'email',
  Expired = 'expired',
  GlobalId = 'globalId',
  Issue = 'i',
  Jwt = 'jwt',
  PostalCode = 'postalCode',
  Redirect = 'redirect',
  Username = 'username',
  SessionId = 'sid',
  ValidationCode = 'ValidationCode', // Legacy api/auth/messaging
}

/**
 * Values for the AuthSearchParam.Expired query parameter.
 */
export enum AuthSessionExpirationReason {
  Idle = 'idle',
}

/**
 * Values for the AuthSearchParam.Issue query parameter.
 * Used to surface contextual messages on redirect (e.g. back to /signup after a bad OTP link).
 */
export enum AuthIssueParam {
  Invalid = 'i',
}
